<div 
    class="image-list" 
    id="images-panel" 
    [dndDropzone]="['external']"
    [dndDisableIf]="slideshow.locked" 
    (dndDrop)="drop($event)"
    [dndAllowExternal]="true">
    <span class="title cf">
        <span class="left">
            <mat-icon>insert_photo</mat-icon> Images
        </span>
        <span class="right">
            <button (click)="openMediaDialog()" *ngIf="!dialog">
                <svg 
                    class="getty-icon" 
                    width="20px" 
                    viewBox="-10 3 40 40" 
                    version="1.1" 
                    xmlns="http://www.w3.org/2000/svg" 
                    xmlns:xlink="http://www.w3.org/1999/xlink" 
                    alt="Getty Images">
                    <defs></defs>
                    <g stroke="none" fill="white">
                        <g>
                            <path d="M9.14097167,12.3754878 C6.98746094,12.3754878 5.48473133,13.9195854 5.48473133,15.8696341 C5.48473133,17.8187561 6.98746094,19.3619268 9.14097167,19.3619268 C11.0506712,19.3619268 12.5941906,17.8187561 12.5941906,15.8696341 C12.5941906,13.9195854 11.0506712,12.3754878 9.14097167,12.3754878 L9.14097167,12.3754878 Z M4.63185579,32.1966585 C4.63185579,33.8213902 6.01221631,34.5526585 10.2376584,34.5526585 C13.4869288,34.5526585 14.5845425,32.9279268 14.5845425,32.1966585 C14.5845425,31.2216341 13.0818129,29.7600244 8.20651674,29.7600244 C5.44394163,29.7600244 4.63185579,31.3031951 4.63185579,32.1966585 L4.63185579,32.1966585 Z M19.3374695,12.0501707 C18.1601305,12.0501707 16.8594953,12.0501707 16.0872721,12.5386098 C16.7371262,13.4320732 17.2256755,14.6499268 17.2256755,16.2746585 C17.2256755,20.2553902 14.5437528,23.0979756 9.26241373,23.0979756 C7.06904034,23.0979756 5.32157253,23.1795366 5.32157253,24.3983171 C5.32157253,27.8099756 19.2160275,23.1795366 19.2160275,31.6275854 C19.2160275,34.6342195 16.1688515,37.8827561 9.42557253,37.8827561 C3.73726352,37.8827561 0.000370815451,36.1773902 0.000370815451,32.8463659 C0.000370815451,30.2067561 1.99072275,28.9471951 3.81884292,28.9471951 L3.81884292,28.866561 C2.84359828,28.2576341 0.691014592,27.7284146 0.691014592,25.4539756 C0.691014592,23.4232927 3.04661974,21.880122 3.98200172,21.5955854 C2.23453391,20.1738293 0.853246352,18.5490976 0.853246352,15.990122 C0.853246352,12.2948537 3.69647382,8.63943902 9.18176137,8.63943902 C10.9690918,8.63943902 13.0818129,9.37070732 14.381521,10.507 C15.3567657,9.20758537 16.9410747,8.55787805 19.3374695,8.63943902 L19.3374695,12.0501707 Z"></path>
                        </g>
                    </g>
                </svg>
            </button>
            <input type="file" #imageInput (change)="imagesService.handleDropFiles($event.target.files, slideshow.assignment, false);" multiple>
            <button *ngIf="!slideshow.locked" type="button" class="faded" (click)="imageInput.click()"><mat-icon>publish</mat-icon></button>
            <span class="upload-count faded" *ngIf="imagesService.uploadInProgress">{{imagesService.progressCount}}/{{imagesService.progressTotal}}</span>
        </span>
    </span>
    <span class="progress" [ngClass]="{active: imagesService.uploadInProgress}"><span class="bar" [style.width]="imagesService.progress + '%'"></span></span>
    <div class="inner-wrap">
        <ul class="images" *ngIf="imagesService.images.length > 0; else noImages">
            <li 
                class="image" 
                *ngFor="let img of imagesService.images; let i = index; trackBy: utils.trackByIndex"
                (click)="clickImage($event, img)">
                <span class="actions">
                    <mat-icon 
                        *ngIf="!slideshow.locked || slideshow.isFeaturedImage(img)"
                        [ngClass]="{featured: slideshow.isFeaturedImage(img)}"
                        title="Set featured image" 
                        (click)="slideshow.toggleFeaturedImage(img)">
                        check
                    </mat-icon>
                    <a href="{{imagesService.getDownloadUrl(img)}}" class="download" title="Download image" target="_blank" download>
                        <mat-icon class="invert">publish</mat-icon>
                    </a>
                    <mat-icon
                        *ngIf="!slideshow.locked"
                        title="Delete image" 
                        (click)="imagesService.deleteImage(slideshow.slides, slideshow.assignment, img)">
                        remove
                    </mat-icon>
                </span>
                <img 
                    [attr.data-image-id]="img.id"
                    [attr.data-image-size]="'thumbnail'"
                    dndType="image"
                    [dndDraggable]="i"
                    [dndEffectAllowed]="'move'"
                    [dndDisableIf]="slideshow.locked"
                    src="{{ img.sizes?.thumbnail?.urlWithParams }}">
            </li>
        </ul>
        <ng-template #noImages>
            <input type="file" #imageInput2 (change)="imagesService.handleDropFiles($event.target.files, slideshow.assignment, false);" multiple>
            <span class="placeholder" *ngIf="!slideshow.locked">Drag images here from Getty or Desktop or <button (click)="imageInput2.click()" type="button">click here</button> to upload</span>
        </ng-template>
    </div>
    <div class="dragover-placeholder" *ngIf="!slideshow.locked">
        <mat-icon>insert_photo</mat-icon>
        <span>Drop Here</span>
    </div>
</div>